import img1 from '/static/img/home/popularProducts/img1.jpg'
import img2 from '/static/img/home/popularProducts/img2.jpg'
import img3 from '/static/img/home/popularProducts/img3.jpg'
const popularProductsList = [
    {
      id:1,
      img:img1,
      title:'Western Sichuan Loop',
      titleDesc:'3 Destinations',//6 destinations:
      desc:'As the folds of the Hengduan Mountains rise, a "heaven - blessed land" in Western Sichuan is formed. Snow - capped mountains are frames, grasslands turn into poems, Tibetan villages seem like frozen melodies, and the Western Sichuan Loop wraps around like a colorful Khata.',
      time:'Recommended duration of stay: 14 days'//Recommended duration of stay: 3 days
    },
    {
        id:3,
        img:img2,
        title:'Chengdu Leisure',
        titleDesc:'8-13 Destinations',
        desc:'The fertile land of Tianfu nurtures Chengdu\'s leisure charm. Pandas bring cuteness at the base, tea fragrance lingers in Kuanzhai Alleys, Dujiangyan irrigates for millennia, and Sanxingdui unlocks ancient Shu mysteries. Where vibes meet civilization, savor Sichuan\'s grace slowly.',
        time:'Recommended duration of stay: 3-7 Days'
    },
    {
        id:5,
        img:img3,
        title:'Guangzhou Vibes',
        titleDesc:'6 Destinations',
        desc:'The Pearl River flows through the city, nurturing Guangzhou\'s lively vibes. Arcaded streets hold local life, morning tea dim sum overflows with fragrance, Cantonese opera carries ancient charm, and Canton Tower overlooks new chapters. Tradition dances with trends, savoring Yangcheng\'s grace gently.',
        time:'Recommended duration of stay: 3-5 Days'
    }
  ]
  export default{
    popularProductsList
  }